<template>
  <Appendix
    title="Phụ lục Thay đổi thông tin"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
    :_showDetails="false"
  >
    <template #cellDetail="item">
      <p class="" v-for="(data, index) in item.appendixChange.arrTypeChanges" :key="index">
        {{ index + 1 }}. {{ data | transfromMccName(configInfoChange.typeChangeInfo) }}
      </p>
      <p
        class="text-info cursor"
        v-if="
          item.appendixChange.existsChangeInfoRes &&
          item.appendixChange.existsChangeInfoRes.existsChangeInfoId
        "
        @click="detail(item.appendixChange.existsChangeInfoRes)"
      >
        Xem chi tiết
      </p>
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>

<script>
  import Appendix from './Appendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'

  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'detail', label: 'Thông tin thay đổi', class: 'text-center' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        configInfoChange: [],
      }
    },
    created() {
      CommonService.getConfigInfoChange().then(data => {
        if (data.success) {
          this.configInfoChange = data.data
        }
      })
    },
    methods: {
      detail(data) {
        if (data && data.existsChangeInfoId) {
          const id = data.existsChangeInfoId
          const routeData = this.$router.resolve({ name: 'detailInfoChange', params: { id } })
          window.open(routeData.href, '_blank', 'noopener,noreferrer,width=800,height=600')
        }
      },
    },
  }
</script>

<style scoped></style>
